import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

export default function ConfirmationDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}) {
  if (!open) return null; // <-- prevents double mounting

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      keepMounted={false}
      transitionDuration={0}   // <--- stops MUI from rendering twice
    >
      <DialogTitle>{title || "Confirm"}</DialogTitle>

      <DialogContent>{message || "Are you sure?"}</DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
